import { useCallback } from 'react';

import { createAtlAttributionHeader } from '../../../../../common/fetch/atl-attribution-header';
import { fetchAggResponse } from '../../../../../common/fetch/fetch-agg-response';

import { CREATE_BOOKMARK_OPERATION_NAME, CreateBookmarkMutation } from './CreateBookmarkMutation';

type CreateBookmarkVariables = {
	orgId: string;
	cloudId: string;
	keyPhrases: string[];
	url: string;
	title: string;
	description: string;
};

type BookmarkError = {
	message?: string;
	extensions?: object;
};

type CreateBookmarkResponseData = {
	knowledgeDiscovery: {
		createBookmark: {
			success: boolean;
			errors?: BookmarkError[];
		};
	};
};

export const useAddBookmarkMutation = () => {
	const createBookmark = useCallback(
		async (variables: CreateBookmarkVariables, workspaceId: string, product: string) => {
			return fetchAggResponse<CreateBookmarkVariables, CreateBookmarkResponseData>({
				graphQuery: CreateBookmarkMutation,
				variables,
				operationName: CREATE_BOOKMARK_OPERATION_NAME,
				headers: createAtlAttributionHeader({
					atlWorkspaceId: workspaceId,
					tenantId: variables.cloudId,
					product,
				}),
			}).then((response) => {
				if (response?.data?.knowledgeDiscovery.createBookmark) {
					const createBookmarkResponse = response?.data?.knowledgeDiscovery.createBookmark;
					return {
						success: createBookmarkResponse.success,
						errors: createBookmarkResponse.errors || [],
					};
				} else {
					throw new Error('createBookmark mutation unsuccessful');
				}
			});
		},
		[],
	);

	return {
		createBookmark,
	};
};
